<mat-card class="chart-widget">
    <mat-card-header>
        <mat-card-title>{{ title }}</mat-card-title>
    </mat-card-header>

    <mat-card-content>
        <div *ngIf="isLoading" class="loading-state">
            <mat-spinner diameter="40"></mat-spinner>
            <p>Loading chart...</p>
        </div>

        <div *ngIf="!isLoading && chartData" class="chart-container">
            <canvas #chartCanvas></canvas>
        </div>

        <div *ngIf="!isLoading && !chartData" class="empty-state">
            <mat-icon>bar_chart</mat-icon>
            <p>No data available</p>
        </div>
    </mat-card-content>
</mat-card>